if($('.type-detail').length){
    if($('.breadcrumbs span#navigation-1 a').text().trim() === 'Palubky'){
        $('.add-to-cart .quantity').remove();
        $('.add-to-cart button').replaceWith('<span class="customFormText">Poptat</div>');
        var newForm = `<div class="inquiryFormInner"><h3 class="col-12">Poptat</h3><form id="inquiryForm">
            <div class="form-row">
                <div class="form-group col-4">
                    <label for="name">Jméno <span class="required">*</span></label>
                    <input type="text" class="form-control" id="name" required>
                </div>
                <div class="form-group col-4">
                    <label for="address">Adresa <span class="required">*</span></label>
                    <input type="text" class="form-control" id="address" required>
                </div>
                <div class="form-group col-4">
                    <label for="email">E-mail <span class="required">*</span></label>
                    <input type="email" class="form-control" id="email" required>
                </div>
                
            </div>
           
            <div class="form-row">
             <div class="form-group col-4">
                        <label for="phone">Telefon</label>
                        <input type="tel" class="form-control" id="phone">
                </div>
                <div class="form-group col-4">
                    <label for="quantity">Množství m2<span class="required">*</span></label>
                    <input type="number" class="form-control" id="quantity" required>
                </div>
                <div class="form-group col-4">
                    <label for="delivery">Doprava <span class="required">*</span></label>
                    <select class="form-control" id="delivery" required>
                        <option value="">Vyberte možnost</option>
                        <option value="S dopravou">S dopravou </option>
                        <option value="Osobní odběr">Osobní odběr</option>
                    </select>
                </div>
            </div>
<div class="form-row">
            <div class="form-group col-12">
                <label for="message">Vzkaz</label>
                <textarea class="form-control" id="message" rows="2"></textarea>
            </div>
             <div class="form-group col-12">
                <input type="submit" class="btn btn-primary" value="Odeslat poptávku">
            </div>
            </div>
            
        </form></div>`
        $('html').on('click', '.customFormText', function(){
            $.colorbox({
                html: newForm,
                maxWidth: shoptet.modal.config.maxWidth,
                maxHeight: shoptet.modal.config.maxHeight,
                width: shoptet.modal.config.widthMd,
                className: shoptet.modal.config.classLg + ' productForm',
                onComplete: function () {
                    
                },
                onClosed: function () {
                    
                }
            });
        })

        
        

    }
    var sku = $('#product-detail-form meta[itemprop="sku"]').attr('content'); 
    if (productInfoByCode.hasOwnProperty(sku)) {
        $('.p-final-price-wrapper .pr-list-unit').append(' (' + productInfoByCode[sku].weight + ' kg)');
    }
    $('.p-info-wrapper').append('<div class="customCart"></div>')
    $('.customCart').append($('.p-final-price-wrapper'))
    $('.customCart').append($('.add-to-cart'))
    $('.p-info-wrapper').append('<div class="stockLine"></div>')
    $('.stockLine').append($('.availability-value'))
    $('.stockLine').append('<span class="customDelivery">Možnost doručení</span>')
    $('.p-info-wrapper').append($('#tab-content .extended-description'))
    $('.p-info-wrapper').append($('.p-detail-inner .p-detail-inner-header').clone())
    $('.p-image-wrapper').append($('.p-detail-info .flags'))
    $('.p-detail').append('<div class="bottomRow"><div class="customPostsFeed"></div></div>')
    $('.p-info-wrapper').append('<table class="customTable"></table>')
    $('.extended-description tr').each(function(){
        var rowText = $(this).find('th').text();
        if(rowText.match('Balení:')){
            $(this).appendTo('.customTable')
        }
        if(rowText.match('PE balíček:')){
            $(this).appendTo('.customTable')
        }
        if(rowText.match('PE - balíček:')){
            $(this).appendTo('.customTable')
        }
        if(rowText.match('Paleta:')){
            $(this).appendTo('.customTable')
        }
      
        if(rowText.match('Big bag:')){
            $(this).appendTo('.customTable')
        }
        if(rowText.match('Množství v balení:')){
            $(this).appendTo('.customTable')
        }
        if(rowText.match('Kusový odběr:')){
            $(this).appendTo('.customTable')
        }
        var rowText = $(this).find('th span').text()
        if(rowText.includes('#Clanek-do-detailu&')) {
            var postUrl = $(this).find('.show-tooltip').attr('title')
            var urlImage = $(this).find('.show-tooltip').attr('title').split('/')
            var findText = $(this).find('span').text().split('&')[1].split(':')[0]
            var CustomPost = '<div class="customPosts">'
                CustomPost += '<div class="image"><img src="/user/documents/upload/detail/'+urlImage[2]+'.svg?v='+new Date().getHours()+'"></div>'
                CustomPost += '<div class="text"><span class="textInner">'+findText+'</span><a href="'+postUrl+'">'+$(this).find('td').text()+'</a></div>'
            CustomPost += '</div>'
            $(this).hide()
            $('.customPostsFeed').append(CustomPost);
        }
    })

    
    $('.bottomRow').append('<div class="contactBox"><h3>Potřebujete se na něco zeptat?</h3><div class="customRow"><div class="left"><p>Pondělí - Pátek 8:00 - 16:00</p></div><div class="right"></div></div></div>')
    $('.contactBox .customRow .left').append($('footer#footer .contact-box').html())
    $('.contactBox .right').append($('.link-icons').html())
    var colorboxContent = '<div class="customDeliveryContent">'
        colorboxContent += '<h4>Možnosti doručení</h4>'
        colorboxContent += '<p>Pro zjištění možností doručení vyplňte PSČ. Následně vám sdělíme možnosti.</p>'
        colorboxContent += '<form id="validateZip"><fieldset>'
        colorboxContent += '<div class="rowLine"><label for="zip">PSČ</label>'
        colorboxContent += '<input type="text" id="zip" placeholder="např. 701 00" title="Vložte vaše PSČ"></div>'
        colorboxContent += '<div class="rowLine"><input type="submit" value="Ověřit" class="btn btn-secondary"></div>'
        colorboxContent += '</fieldset></form>'
    colorboxContent += '</div>'
    $(document).on('click', '.customDelivery', function(){
        $.colorbox({
            html: colorboxContent,
            width: 600,
            maxWidth: "95%",
            height: 500,
            maxHeight: "95%",
            className: "chooseSize",
            onComplete: function() {
                validateVat()
            },
        });
    })
    function validateVat(){
        $('form#validateZip').on('submit', function(e) {
            e.preventDefault();
            $('.deliveryRow').remove();
            var userZip = $('#zip').val().replace(/\s/g, ''); // Získání PSČ bez mezer
            var productCode = $('#product-detail-form meta[itemprop="sku"]').attr('content'); // Získání kódu produktu
            if (!userZip || !productCode) {
                console.log("Chybí PSČ nebo kód produktu.");
                return;
            }
            if (typeof productInfoByCode !== 'undefined' && productInfoByCode[productCode]) {
                var shippingType = productInfoByCode[productCode].shipping; // "yes" nebo "no"
                var apiUrl = 'https://tools.shopcode.cz/api/ekopaliva/get-psc.php?productCode=' + encodeURIComponent(productCode) + '&psc=' + encodeURIComponent(userZip)+'&table=detail_' + encodeURIComponent(shippingType);;
                $.getJSON(apiUrl, function(response) {
                    if (response.error) {
                        console.log("Chyba: " + response.error);
                    } else {
                        response.data.forEach(function(item) {
                            $('#zip').after(
                                '<div class="deliveryRow '+response.class+'" style="margin-top:15px;">'+item.bez_rosahu+'</div>'
                            );
                        });
                    }
                }).fail(function() {
                    console.log("Chyba při načítání dat z API.");
                });
            } else {
                console.log("Produkt s kódem " + productCode + " nebyl nalezen v productInfoByCode.");
            }
        });
    }
}